export { Subtitle1 } from './Subtitle1';
export { subtitle1ClassNames } from './useSubtitle1Styles.styles';
